import { useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom'
import request, { METHODS } from '@/api'
import { useSetState } from 'ahooks'
import { useActivate } from 'react-activation'
import { SDrawer, SFuncModal, SLowcodeList, STableActions } from 'shj-components'

// import {
//   elecContractForeceDelted,
//   elecContractListAll,
//   elecContractReaginSignElec,
// } from "@/services/quotationManage.ts";
import config from './config.ts'
// import ContractHistoryDom
//   from "@/pages/InformationManager/quotationManage/detailTables/contractList/modal/contractHistoryModal";
import ContractDetailDom from './modal/detail/index.tsx'
import { message, Upload } from 'antd'
import ImageUpload, { AcceptType } from '@/components/Upload/ImageUpload.tsx'
import { getFileUrlPrefix, useFileUrlPrefix } from 'shj-utils'
import { getElecConctList, delElecConct, getElecConctSupport } from '@/services/order.ts'
import SubmitSignContract from '@/components/SubmitSignContract'

const ContractList = props => {
  const listRef = useRef()
  const detailRef = useRef()
  const [imagePrefix] = useFileUrlPrefix()
  const { id } = useParams() // 订单id

  const [state, setState] = useSetState<any>({
    visible: false,
    data: {},
    signVisible: false,
    signReadOnly: false,
    submitLoading: false,
    signSignVisible: false,
    elecContractId: '',
    signData: [],
    signDataNew: [],
    tableList: [],
  })
  const [currentFileList, setCurrentFileList] = useState([])
  const [quoteId, setQuoteId] = useState('')
  const [title, setTitle] = useState('')

  const fetchList = () => {
    return new Promise((resolve, reject) => {
      try {
        getElecConctSupport({ data: { orderIds: [id], modeFlags: [1, 2] } }).then(res => {
          // setState({ tableList: res || [] })
          resolve({
            records: res,
          })
        })
      } catch {
        reject({ success: false })
      }
    })
  }

  const onDetail = record => {
    if (record.targetFileUrl || record.srcFileUrl) {
      const url = getFileUrlPrefix() + (record.targetFileUrl || record.srcFileUrl)
      window.open(url)
      return
    }

    if (
      (record.flowState !== 'complete' && !record?.configJson?.quotaContractInfo?.onlineFlag) ||
      (record.flowState === 'complete' && !record?.configJson?.quotaContractInfo?.onlineSignFlag)
    ) {
      const fileList = record?.attachs?.map(item => ({
        ...item,
        url: imagePrefix + item?.attachPath,
        name: item?.attachName,
      }))
      setCurrentFileList(fileList || [])
      setTitle('预览')
      setState({
        signSignVisible: true,
        elecContractId: record.id,
        signReadOnly: true,
        quoteContractId: record?.configJson?.quotaContractInfo?.id,
      })
    } else {
      message.info('无pdf链接')
    }
  }

  const onClose = () => {
    setState({ visible: false, data: {} })
  }

  const onSubmit = () => {
    detailRef.current?.onFinish()
  }

  const onDel = async id => {
    try {
      const res = await delElecConct(id)
      if (res?.errorCode === 0) {
        message.success('删除成功')
        listRef.current?.reload()
      }
    } catch (err) {
      message.error('删除失败')
    }
  }
  const onReSign = id => {
    // elecContractReaginSignElec(id).then(res => {
    //   message.success(res.message, 6);
    //   listRef.current?.reload();
    // })
  }

  const onSubmitSign = record => {
    setTitle('提交签约')
    setCurrentFileList([])
    setQuoteId(record?.budgetId)
    setState({
      signSignVisible: true,
      elecContractId: record.id,
      signReadOnly: false,
      quoteContractId: record?.configJson?.quotaContractInfo?.id,
    })
  }

  const extensions = {
    request: { fetchList },
    customRender: {
      operation(_, record) {
        return (
          <STableActions>
            <STableActions.SActionBtn
              // auth={record.isOnlineFlag ? 'QuotaContractViewBtn' : 'QuotaContractSubmitSignBtn'}
              // disabled={!detail.operatorFlag}
              // {...{ [!detail.operatorFlag ? 'tipText' : '']: getToolTip() }}
              onClick={() => onDetail(record)}
            >
              预览
            </STableActions.SActionBtn>
            {!record?.configJson?.quotaContractInfo?.onlineSignFlag &&
              record?.flowState === 'waitSign' && (
                <STableActions.SActionBtn
                  // auth={'QuotaContractSubmitSignBtn'}
                  // disabled={record.flowState !== 'waitSign' || !detail.operatorFlag}
                  // {...{
                  //   [!detail.operatorFlag ? 'tipText' : '']: getToolTip(
                  //     record.flowState !== 'waitSign'
                  //   ),
                  // }}
                  onClick={() => onSubmitSign(record)}
                >
                  提交签约
                </STableActions.SActionBtn>
              )}
            <STableActions.SActionBtn
              disabled={
                record.flowState === 'complete' ||
                record.flowState === 'backOrder' ||
                record.flowState === 'waitAudit' ||
                record.flowState === 'waitSign'
              }
              // auth={'QuotaContractDeleteBtn'}
              // disabled={!detail.operatorFlag}
              title="确认删除?"
              danger
              confirm
              onClick={() => onDel(record.id)}
            >
              删除
            </STableActions.SActionBtn>

            {/*<STableActions.SActionBtn auth={'QuotaContractReSignBtn'} title="是否重签?" confirm
                                    disabled={record.flowState !== 'complete' || !detail.operatorFlag}
                                    {...{[!detail.operatorFlag ? 'tipText' : '']: getToolTip(record.flowState !== 'complete')}}
                                    onClick={() => onReSign(record.id)}> 重签 </STableActions.SActionBtn>*/}
          </STableActions>
        )
      },
    },
  }

  return (
    <>
      <SLowcodeList searchMode={'group'} ref={listRef} config={config} {...extensions} />
      {state.signSignVisible && (
        <SubmitSignContract
          state={state}
          setState={setState}
          open={state.signSignVisible}
          currentFileList={currentFileList}
          quoteId={quoteId}
          reload={() => listRef.current?.reload()}
          title={title}
        />
      )}
    </>
  )
}

export default ContractList
// (props) => {
//   const location = useLocation();
//
//   return <KeepAlive name={location.pathname}>
//     <ContractList {...props}/>
//   </KeepAlive>
// }
